import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[libAuthContent]',
})
export class AuthContentDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
